<template>
  <div v-if="current">
    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-6 col-sm-1">
              <v-text-field label="Nome" v-model="current.name" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Código" v-model="current.code" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select label="Modelo" v-model="current.model" :items="model" outlined dense></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Host" v-model="current.host" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Porta" v-model="current.port" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Usuário" v-model="current.username" outlined dense></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field label="Senha" v-model="current.password" outlined dense></v-text-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8 col-sm-1">
              <v-text-field label="Localização" v-model="current.location" outlined dense></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select label="Status" v-model="current.enabled" :items="enabled" outlined dense></v-select>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
          <v-btn color="success" @click="save()">Salvar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    enabled: [
      { text: "Ativado", value: true },
      { text: "Desativado", value: false }
    ],
    model: [
      { text: "MA5800-X2", value: 1 },
      { text: "MA5800-X7", value: 2 },
      { text: "MA5800-X15", value: 3 },
      { text: "MA5800-X17", value: 4 }
    ]
  }),
  created: function() {
    this.load();
  },
  methods: {
    load: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/olt/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token }
        })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function() {
          console.log("olt fail");
        });
    },
    save: function() {
      var token = localStorage.getItem("token");
      if (this.current.id == 0) {
        api
          .post("/olt", this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("OLT cadastrada com sucesso!");
            router.push({ path: "/olt" });
          });
      } else {
        api
          .put("/olt/" + this.current.id, this.current, {
            headers: { Authorization: "Bearer " + token }
          })
          .then(function() {
            alert("OLT atualizada com sucesso!");
            router.push({ path: "/olt" });
          });
      }
    }
  }
};
</script>